import { createPinia } from 'pinia';
import useAppStore from './modules/app';
import useUserStore from './modules/user';
import useRouterStore from './modules/router';
import useTabBarStore from './modules/tab-bar';
import useBusinessStore from './modules/business';
import useModalStore from './modules/modal';
import useMaterialStore from './modules/material';
import useSupplierStore from './modules/supplier';
import useMessageStore from './modules/message';
import useSubscribeStore from './modules/subscribe';

const pinia = createPinia();

export {
  useAppStore,
  useUserStore,
  useRouterStore,
  useTabBarStore,
  useBusinessStore,
  useModalStore,
  useMaterialStore,
  useSupplierStore,
  useMessageStore,
  useSubscribeStore,
};
export default pinia;
